// This file is AUTOGENERATED, do not edit it manually!!!

export const portfolios = {
    add_portfolio: 'Añadir portafolio',
    delete_portfolio_title: 'Eliminar portafolio {0}?',
    DeletionIsUsedDisabled: 'El estado no se puede eliminar ya que hay una portafolio con este estado.',
    Editor: 'Portafolio editor',
    Manager: 'Gestor de portafolio',
    members: '1#{0} miembro de portafolio#{0} miembros de portafolio',
    new_portfolio: 'Nueva portafolio',
    NewStatusTitle: 'Añadir estado',
    ParentPortfolio: 'Portafolio de patentes',
    permissions_title: 'Este rol tiene los siguientes permisos con respecto a portafolio y los proyectos que contiene',
    Portfolios: 'Portafolios',
    role_for_this_portfolio: 'Rol para este portafolio:',
    Statuses: 'Estado',
    Teamer: 'Participante de portafolio',
    Viewer: 'Visor de portafolio',
};
